/**
 * Pay-as-you-go minimum, shown before a job starts (F2). Only a pay-as-you-go account sees it.
 * Before the effective date it is the advance notice; from the date it states the exact charge for a
 * file shorter than the floor that paid pre-change balance does not cover. All wording and the
 * decision come from the pure selector paygFloorUpload in lib/paygFloor.ts.
 */
import { useProfile } from '../store/useAuthStore';
import { paygFloorUpload } from '../services/paygFloor';

export default function PaygFloorNotice({ durationSeconds }: { durationSeconds: number | null }) {
  const profile = useProfile();
  const notice = paygFloorUpload({
    plan: profile?.plan,
    durationSeconds,
    balanceSeconds: profile?.balance_seconds,
    legacySeconds: profile?.legacy_paid_seconds,
  });
  if (!notice.message) return null;
  return (
    <div role="status" data-testid="payg-floor-notice" className="px-4 py-3 bg-amber-50 border border-amber-200 rounded-xl text-sm text-amber-800 space-y-1">
      <p>{notice.message}</p>
      {notice.lowBalance && <p>{notice.lowBalance}</p>}
    </div>
  );
}
